<app-card [showHeader]="false" cardClass="user-card" padding="20">
  <div class="flex align-items-center">
    <div class="flex-shrink-0">
      @if (profileImage) {
      <img [src]="profileImage" alt="user-image" style="width: 50px; height: 50px; border-radius: 50%" />
      } @else {
      <img src="assets/images/user-placeholder.png" alt="user-image" style="width: 50px; height: 50px" />
      }
    </div>
    <div class="flex-grow-1 user-details">
      <div class="f-w-600">{{ userName }}</div>
      <div class="mat-caption">{{ userRole }}</div>
      @if(userCompany || userBranch) {
      <div class="mat-caption">
        {{userCompany}} | {{userBranch}}
      </div>
      }

    </div>
    <app-user-setting></app-user-setting>
  </div>
</app-card>